export const environment = {
  production: true,
  urlApi: 'https://d2svs346bx6137.cloudfront.net/',
  apiUrl: 'https://api.cancianimoveis.com.br',
  appSorteosKey: 'klhegDzQ'
};

